import React from "react";
import CustomerSvg from "assets/images/customer_service.svg";
import BadgeSvg from "assets/images/business.svg";
import ClockSvg from "assets/images/fast_delivery.svg";
import SuitCaseSvg from "assets/images/guarantee.svg";
import videoTranslationPageData from "utils/StaticPageJson/videoTranslation.json";

const DEFAULT_CHOOSE_US_DATA =
  videoTranslationPageData.videoTranslation.quote_what_choose_us;

export default function QuoteWhatChooseUs({
  backgroundCol,
  LanguageName,
  languages,
  textColor,
  secondaryBg,
  isInterpretationServices,
  pageData,
}) {
  const chooseUsData = pageData
    ? pageData.quote_what_choose_us
    : DEFAULT_CHOOSE_US_DATA;

  const interpretationData = chooseUsData?.interpretation_services;

  const professionalData = chooseUsData?.professional_translation;

  const videoData = chooseUsData?.video_translation;

  const currentData = isInterpretationServices
    ? interpretationData
    : languages
    ? professionalData
    : videoData;

  const icons = [CustomerSvg, BadgeSvg, ClockSvg, SuitCaseSvg];

  return (
    <section
      className={`${
        backgroundCol ? backgroundCol : "bg-midBlue"
      } pt-24 pb-16 relative`}
    >
      <div className="container mx-auto px-4 lg:w-9/12">
        {/* Heading */}
        <div>
          {currentData?.title?.override_language_heading ? (
            <h2
              className={`text-[35px] text-center ${
                textColor ? textColor : "text-white"
              } font-secondary font-bold leading-10 pl-4`}
            >
              {currentData?.title?.prefix}{" "}
              <span className="text-[#042C7F]">
                {currentData?.title?.highlight}
              </span>{" "}
              {currentData?.title?.text}
            </h2>
          ) : isInterpretationServices ? (
            <h2 className="text-[35px] text-center text-white font-secondary font-bold leading-10 pl-4">
              {currentData?.title?.normal}{" "}
              <span className="text-[#042C7F]">
                {currentData?.title?.highlight} &nbsp;
              </span>
              {currentData?.title?.text}
            </h2>
          ) : LanguageName ? (
            <h2
              className={`text-[35px] text-center ${
                textColor ? textColor : "text-white"
              } font-secondary font-bold leading-10 uppercase pl-4`}
            >
              <span className="text-[#042C7F]">
                {currentData?.title?.highlight} &nbsp;
              </span>
              CHOOSE TOMEDES {LanguageName} TRANSLATION SERVICE
            </h2>
          ) : (
            <h2
              className={`text-[35px] text-center ${
                textColor ? textColor : "text-white"
              } font-secondary font-bold leading-10 uppercase pl-4`}
            >
              <span className="text-[#042C7F]">
                {currentData?.title?.highlight} &nbsp;
              </span>
              {currentData?.title?.text}
            </h2>
          )}
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 place-items-center place-content-center py-8 gap-10 md:grid-cols-2 md:gap-4 md:max-w-xl mx-auto lg:flex lg:flex-row lg:max-w-screen-xl lg:gap-0 lg:space-x-4 lg:items-stretch">
          {currentData?.cards?.map((card, index) => (
            <div
              key={index}
              className={`${
                secondaryBg
                  ? `${secondaryBg} text-black border-[#777777]`
                  : "bg-darkBlue text-white border-quotetext-200"
              } border rounded-xl text-center px-10 py-12 mx-10 md:mx-0 lg:flex-1`}
            >
              <img
                src={icons[index]}
                alt={card?.title}
                className="m-auto h-[55px] object-contain"
              />

              <h3 className="text-md py-4 font-semibold font-secondary min-h-[80px]">
                {card?.title}
              </h3>

              <ul className="text-left list-disc text-sm font-opensans">
                {card?.points?.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
